import { Table, TableRow, TableCell, WidthType, BorderStyle, Paragraph, TableLayoutType } from 'docx';
import { createGeneralInfoTable } from './generalInfoTable.js';
import { createTemyizTalebindeBulunanlarTable } from './temyizTalebindeBulunanlarTable.js';
import { createSanikSabikasıTable } from './sanikSabikasıTable.js';
import { createTetkikHakimiGorusuTable } from './tetkikHakimiGorusuTable.js';
import { DEFAULT_CONTENT_WIDTH, splitWidth } from './utils.js';

export const createSideBySideTable = (
  generalInfo,
  temyizTalebindeBulunanlarInfo,
  sanikSabikasıInfo,
  tetkikHakimiGorusuInfo,
  contentWidth = DEFAULT_CONTENT_WIDTH
) => {
  // Sol %48 · orta boşluk %4 · sağ %48 (sabit twip). İç tablolar sütun
  // genişliklerini bu değerlerden alır → Mac görüntüleyicide hizalı kalır.
  const [leftW, gapW, rightW] = splitWidth(contentWidth, [0.48, 0.04, 0.48]);

  const generalInfoTable = createGeneralInfoTable(generalInfo, leftW);
  const temyizTalebindeBulunanlarTable = createTemyizTalebindeBulunanlarTable(temyizTalebindeBulunanlarInfo, rightW);
  const sanikSabikasıTable = createSanikSabikasıTable(sanikSabikasıInfo, rightW);
  const tetkikHakimiGorusuTable = createTetkikHakimiGorusuTable(tetkikHakimiGorusuInfo, rightW);

  const rightColumnChildren = [temyizTalebindeBulunanlarTable];
  
  if (sanikSabikasıInfo && Object.keys(sanikSabikasıInfo).length > 0) {
    rightColumnChildren.push(new Paragraph({}), sanikSabikasıTable);
  }
  
  if (tetkikHakimiGorusuInfo && Object.keys(tetkikHakimiGorusuInfo).length > 0) {
    rightColumnChildren.push(new Paragraph({}), tetkikHakimiGorusuTable);
  }

  return new Table({
    width: { size: contentWidth, type: WidthType.DXA },
    layout: TableLayoutType.FIXED,
    columnWidths: [leftW, gapW, rightW],
    borders: {
      top: { style: BorderStyle.NONE },
      bottom: { style: BorderStyle.NONE },
      left: { style: BorderStyle.NONE },
      right: { style: BorderStyle.NONE },
      insideHorizontal: { style: BorderStyle.NONE },
      insideVertical: { style: BorderStyle.NONE },
    },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [generalInfoTable],
            width: { size: leftW, type: WidthType.DXA },
            borders: {
              right: { style: BorderStyle.NONE },
            },
          }),
          new TableCell({
            children: [new Paragraph({})],
            width: { size: gapW, type: WidthType.DXA },
            borders: {
              left: { style: BorderStyle.NONE },
              right: { style: BorderStyle.NONE },
            },
          }),
          new TableCell({
            children: rightColumnChildren,
            width: { size: rightW, type: WidthType.DXA },
            borders: {
              left: { style: BorderStyle.NONE },
            },
          }),
        ],
      }),
    ],
  });
};